let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Msk6")).then(() => parcelRequire('gxTpL'));